import { useState } from 'react';
import JobCarousel from './components/JobCarousel';
import FormPopup from './components/FormPopup';

export default function Home() {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const scrollToJobs = () => {
    const jobsSection = document.getElementById('jobs-section');
    if (jobsSection) {
      jobsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* ファーストビュー */}
      <section className="relative flex flex-col bg-gradient-to-b from-pink-50 to-white">
        {/* ヘッダー */}
        <div className="px-5 py-3 relative z-10 bg-pink-500">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/2eeb7004bec3dab6605078c5e30f883b/648ebd4c62813b21bc546edb325646a9.png"
                alt="ニジ看護転職ロゴ"
                className="w-8 h-8 object-contain"
              />
            </div>
            <div className="text-white text-base font-bold">
              ニジ看護転職
            </div>
          </div>
        </div>

        {/* 背景画像 */}
        <div className="relative h-[50vh]">
          <img
            src="https://static.readdy.ai/image/2eeb7004bec3dab6605078c5e30f883b/fbe069ea8ada52b03d2f8456a100cfe6.jpeg"
            alt="看護師"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-white/80 via-white/70 to-white/90"></div>
        </div>

        {/* メインコンテンツ */}
        <div className="absolute inset-0 flex flex-col justify-end px-5 pb-8 z-10" style={{ top: '60px' }}>
          <div>
            <h1 className="text-3xl font-bold leading-tight text-gray-900 mb-4 text-center">
              条件だけ良くする転職
            </h1>

            {/* CTAボタン */}
            <button
              id="cta-job-condition"
              data-cta="job-condition"
              onClick={() => setIsFormOpen(true)}
              className="w-full bg-pink-500 hover:bg-pink-600 text-white font-bold py-4 rounded-lg shadow-lg transition-all whitespace-nowrap cursor-pointer text-base"
            >
              求人条件のヒアリングへ
            </button>
            
            {/* 注釈 */}
            <p className="text-xs text-gray-500 text-center mt-2">
              ※費用はかかりません
            </p>
          </div>
        </div>
      </section>

      {/* 求人カルーセル */}
      <section id="jobs-section" className="py-8 px-5 bg-white">
        <h2 className="text-xl font-bold text-gray-900 mb-2">
          条件が良くなる求人の一例
        </h2>
        <p className="text-xs text-gray-500 mb-5">
          同じ診療科でも、病院によって条件は大きく変わります
        </p>
        
        <JobCarousel />

        <div className="mt-4 space-y-1 text-xs text-gray-500">
          <p>※掲載は一例です</p>
          <p>※条件は経験・時期により異なります</p>
          <p>※すべての方に当てはまるわけではありません</p>
        </div>

        <button
          id="cta-job-condition"
          data-cta="job-condition"
          onClick={() => setIsFormOpen(true)}
          className="w-full bg-pink-500 hover:bg-pink-600 text-white font-bold py-4 rounded-lg shadow-lg transition-all whitespace-nowrap cursor-pointer mt-6 text-base"
        >
          求人条件のヒアリングへ
        </button>
      </section>

      {/* なぜ同じ診療科で条件が変わるのか */}
      <section className="py-8 px-5 bg-pink-50">
        <h2 className="text-xl font-bold text-gray-900 mb-5">
          なぜ「同じ診療科」で<br />条件が変わるのか
        </h2>

        <div className="space-y-4">
          <div className="bg-white rounded-lg p-4 shadow-sm">
            <h3 className="font-bold text-gray-900 mb-2 text-base">病院ごとの制度差</h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              基本給のテーブル、手当の設定、賞与の計算方法は病院によって全く異なります
            </p>
          </div>

          <div className="bg-white rounded-lg p-4 shadow-sm">
            <h3 className="font-bold text-gray-900 mb-2 text-base">夜勤人数・配置の違い</h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              同じ病床数でも、夜勤の人数配置や2交代・3交代の運用は病院ごとに違います
            </p>
          </div>

          <div className="bg-white rounded-lg p-4 shadow-sm">
            <h3 className="font-bold text-gray-900 mb-2 text-base">残業の実態</h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              残業代の全額支給、記録時間の扱い、業務効率化の進み具合も環境次第です
            </p>
          </div>
        </div>

        <div className="mt-5 bg-white border-l-4 border-pink-500 p-4 rounded">
          <p className="text-sm text-gray-700 leading-relaxed">
            <strong className="text-pink-600">努力不足ではありません。</strong><br />
            同じ仕事でも、環境が違えば条件は変わります。
          </p>
        </div>
      </section>

      {/* 転職の進め方 */}
      <section className="py-8 px-5 bg-white">
        <h2 className="text-xl font-bold text-gray-900 mb-5">
          転職の進め方
        </h2>

        <div className="space-y-3">
          <div className="bg-pink-50 rounded-lg p-4 shadow-sm">
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 bg-pink-100 text-pink-600 rounded-full flex items-center justify-center flex-shrink-0 font-bold text-xs">
                1
              </div>
              <p className="text-sm font-bold text-gray-900">希望のヒアリング</p>
            </div>
          </div>

          <div className="bg-pink-50 rounded-lg p-4 shadow-sm">
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 bg-pink-100 text-pink-600 rounded-full flex items-center justify-center flex-shrink-0 font-bold text-xs">
                2
              </div>
              <p className="text-sm font-bold text-gray-900">書類サポート</p>
            </div>
          </div>

          <div className="bg-pink-50 rounded-lg p-4 shadow-sm">
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 bg-pink-100 text-pink-600 rounded-full flex items-center justify-center flex-shrink-0 font-bold text-xs">
                3
              </div>
              <p className="text-sm font-bold text-gray-900">面接対策</p>
            </div>
          </div>

          <div className="bg-pink-50 rounded-lg p-4 shadow-sm">
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 bg-pink-100 text-pink-600 rounded-full flex items-center justify-center flex-shrink-0 font-bold text-xs">
                4
              </div>
              <p className="text-sm font-bold text-gray-900">面接</p>
            </div>
          </div>

          <div className="bg-pink-50 rounded-lg p-4 shadow-sm">
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 bg-pink-100 text-pink-600 rounded-full flex items-center justify-center flex-shrink-0 font-bold text-xs">
                5
              </div>
              <p className="text-sm font-bold text-gray-900">最終判断</p>
            </div>
          </div>
        </div>

        <div className="mt-5 bg-white border-2 border-pink-500 p-4 rounded-lg">
          <p className="text-sm text-gray-900 font-bold text-center leading-relaxed">
            今すぐ転職する必要はありません<br />
            条件確認だけでも大丈夫です
          </p>
        </div>
      </section>

      {/* 失敗しないためのスタンス */}
      <section className="py-8 px-5 bg-pink-50">
        <h2 className="text-xl font-bold text-gray-900 mb-5">
          本サービスの方針
        </h2>

        <div className="space-y-4">
          <div className="flex items-start gap-3">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
              <i className="ri-checkbox-circle-fill text-pink-500 text-xl"></i>
            </div>
            <p className="text-sm text-gray-900 leading-relaxed pt-0.5">
              <strong>無理に転職は勧めない</strong><br />
              条件が合わない場合は、正直にお伝えします
            </p>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
              <i className="ri-checkbox-circle-fill text-pink-500 text-xl"></i>
            </div>
            <p className="text-sm text-gray-900 leading-relaxed pt-0.5">
              <strong>条件が合わなければ紹介しない</strong><br />
              無理な提案はしません
            </p>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
              <i className="ri-checkbox-circle-fill text-pink-500 text-xl"></i>
            </div>
            <p className="text-sm text-gray-900 leading-relaxed pt-0.5">
              <strong>見学・辞退も前提</strong><br />
              実際に見て判断してください
            </p>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
              <i className="ri-checkbox-circle-fill text-pink-500 text-xl"></i>
            </div>
            <p className="text-sm text-gray-900 leading-relaxed pt-0.5">
              <strong>合わなければ進まなくていい</strong><br />
              無理に進める必要はありません
            </p>
          </div>
        </div>

        <button
          id="cta-job-condition"
          data-cta="job-condition"
          onClick={() => setIsFormOpen(true)}
          className="w-full bg-pink-500 hover:bg-pink-600 text-white font-bold py-4 rounded-lg shadow-lg transition-all whitespace-nowrap cursor-pointer mt-6 text-base"
        >
          求人条件のヒアリングへ
        </button>
      </section>

      {/* フッター */}
      <footer className="py-6 px-5 bg-pink-50 text-center">
        <div className="text-sm text-gray-600 mb-2">
          ニジ看護転職
        </div>
        <div className="text-xs text-gray-500">
          © 2026 Nijikango tenshoku
        </div>
      </footer>

      {/* フォームポップアップ */}
      <FormPopup isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </div>
  );
}